import React, { useState } from "react";
import { Document, Page } from "react-pdf";
const pdfURL = "../assets/terms/PrivacyPolicy.pdf";
// import terms from "./../assets/terms/";
const PdfReader = ({ path }) => {
  return (
    <div>
      <iframe
        src="../assets/terms/PrivacyPolicy.pdf"
        width="100%"
        height="500px"
      />

      {/* <Document file={pdfURL}>
        <Page pageNumber={1} />
      </Document> */}
    </div>
  );
};

export default PdfReader;
